import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    base: "",
    grid: "grid grid-rows-[auto_1fr] grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 data-[grid-size=large]:grid-cols-1 data-[grid-size=large]:md:grid-cols-2 data-[grid-size=large]:lg:grid-cols-3 data-[grid-size=large]:2xl:grid-cols-4 gap-component-spacing-4xs transition-all",
    list: "grid col-span-full row-span-2 grid-cols-subgrid gap-component-spacing-xs lg:gap-component-spacing-lg gap-y-10 auto-rows-max grid-flow-dense group/product-list",
    filter: "hidden lg:block row-start-2",
    item: "grid",
    loadMore: "col-span-full",
    descriptionWrapper: "grid grid-cols-2 gap-component-spacing-sm lg:gap-component-spacing-xl lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 *:col-span-full lg:*:col-start-2 lg:*:col-end-[-2] mt-4 mb-8 lg:mt-6 lg:mb-12 xl:mt-10 xl:mb-16",
    description: "",
    linkBelowList: "flex items-center gap-2 text-body-sm",
    shortcutNav: ""
  },
  variants: {
    columns: {
      1: { base: "!grid-cols-1" },
      2: { base: "!grid-cols-2" },
      3: { base: "!grid-cols-3" },
      4: { base: "!grid-cols-4" },
      5: { base: "!grid-cols-5" },
      6: { base: "!grid-cols-6" },
      7: { base: "!grid-cols-7" },
      8: { base: "!grid-cols-8" },
      9: { base: "!grid-cols-9" },
      10: { base: "!grid-cols-10" },
      11: { base: "!grid-cols-11" },
      12: { base: "!grid-cols-12" }
    },
    columnSpan: {
      1: { item: "col-span-1" },
      2: { item: "col-span-2" },
      3: { item: "col-span-3" },
      4: { item: "col-span-4" },
      5: { item: "col-span-5" },
      full: { item: "col-span-full" }
    },
    rowSpan: {
      1: { item: "row-span-1" },
      2: { item: "row-span-2" },
      3: { item: "row-span-3" },
      4: { item: "row-span-4" },
      5: { item: "row-span-5" },
      full: { item: "row-span-full" }
    }
  }
}), s = e({
  slots: {
    base: "flex flex-row-reverse justify-between items-center w-full col-span-full transition-shadow px-4 lg:px-12 py-4 bg-white -mb-4 lg:-mb-6",
    filterTrigger: "relative uppercase text-label-md pl-3 before:content-[''] before:absolute before:left-0 before:top-1/2 before:w-[5px] before:h-[5px] before:-translate-y-1/2 before:bg-current hover/:before:animate-blink-square tracking-wide",
    filterTriggerIcon: "w-4 h-4",
    activeFilters: "flex flex-wrap gap-2 empty:hidden",
    headerProducts: "text-body-sm text-text-less-emphasis-2 w-full text-left"
  },
  variants: {}
}), r = e({
  slots: {
    base: "mx-auto h-14 transition-[height] lg:h-20 gap-6 col-span-full items-center w-full bg-white data-[is-pinned=true]:lg:h-16 flex flex-row-reverse",
    filterTrigger: "hidden lg:flex",
    stickyFilterTrigger: "fixed bottom-0 lg:mx-auto z-50 flex justify-center w-full right-0 left-0 lg:hidden data-[is-pinned=false]:opacity-20 translate-y-16 data-[is-pinned=true]:-translate-y-4 data-[is-pinned=true]:opactity-100 transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]",
    headerProducts: "text-body-xs lg:text-body-sm text-less-emphasis-1 ",
    toggleGridSize: "flex lg:gap-1 h-11 ml-auto",
    toggleGridSizeButton: "py-3 px-2 cursor-pointer last:-mr-2 [&>svg]:w-4 lg:[&>svg]:w-5"
  },
  variants: {}
});
export {
  r as a,
  l as b,
  s as p
};
//# sourceMappingURL=blueprint-60d67528.mjs.map
